import { css, type ExecutionContext } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomTypographyProps = {
  body1?: boolean
  body2?: boolean
  caption?: boolean
  header5?: boolean
  header6?: boolean
  overline?: boolean
  subtitle2?: boolean
}

const body1Css = ({ body1 }: ExecutionContext & { body1?: boolean }) =>
  body1 &&
  css`
    font-size: 16px;
    font-weight: ${themeGet('fontWeights.0')};
    line-height: 24px;
    letter-spacing: -0.25px;
  `

const body2Css = ({ body2 }: ExecutionContext & { body2?: boolean }) =>
  body2 &&
  css`
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.0')};
    line-height: 20px;
    letter-spacing: -0.2px;
  `

const captionCss = ({ caption }: ExecutionContext & { caption?: boolean }) =>
  caption &&
  css`
    font-size: 12px;
    font-weight: ${themeGet('fontWeights.1')};
    line-height: 16px;
    letter-spacing: -0.25px;
  `

const header5Css = ({ header5 }: ExecutionContext & { header5?: boolean }) =>
  header5 &&
  css`
    font-size: 26px;
    font-weight: ${themeGet('fontWeights.1')};
    line-height: 32px;
    letter-spacing: -0.5px;
  `

const header6Css = ({ header6 }: ExecutionContext & { header6?: boolean }) =>
  header6 &&
  css`
    font-size: 20px;
    font-weight: ${themeGet('fontWeights.2')};
    line-height: 24px;
    letter-spacing: -0.5px;
  `

const overlineCss = ({ overline }: ExecutionContext & { overline?: boolean }) =>
  overline &&
  css`
    font-size: 12px;
    font-weight: ${themeGet('fontWeights.2')};
    line-height: 16px;
    letter-spacing: -0.5px;
  `

const subtitle2Css = ({
  subtitle2,
}: ExecutionContext & { subtitle2?: boolean }) =>
  subtitle2 &&
  css`
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.2')};
    line-height: 20px;
    letter-spacing: -0.2px;
  `

export type { CustomTypographyProps }
export {
  body1Css,
  body2Css,
  captionCss,
  header5Css,
  header6Css,
  overlineCss,
  subtitle2Css,
}
